module.exports = __webpack_public_path__ + "static/media/Sylla.da5f9c32.md";